// extracted by mini-css-extract-plugin
module.exports = {"app":"styles_app__lkwrT"};